import { Provider } from './providers.types';

export default function Giphy(): Provider {

  return {
    mount
  };

  async function mount(element, url) {
    element.classList.remove('social-embed--rendered');

    const gifId = getGifId(url);
    const contentElement = element.querySelector('[data-content]');

    contentElement.innerHTML = `
    <div style="width:100%;height:0;padding-bottom:56%;position:relative;">
      <iframe
        src="https://giphy.com/embed/${gifId}"
        width="100%"
        height="100%"
        style="position:absolute"
        frameBorder="0"
        class="giphy-embed"
        allowFullScreen
        >
      </iframe>
    </div>
    `;
  }
}


/*
* Possible links:
* https://giphy.com/gifs/fcbayern-goal-bayern-3o7aD0kF1xNXNeeVHy
* https://media.giphy.com/media/3o7aD0kF1xNXNeeVHy/giphy.gif
* https://giphy.com/gifs/3o7aD0kF1xNXNeeVHy/html5
* 3o7aD0kF1xNXNeeVHy (just the GIF ID)
*
* NO SUPPORT FOR SHORT LINKS
*/
function getGifId(url = '') {
  const urlSections = url.split('/');

  if (urlSections.length === 1) {
    return urlSections[0].trim();
  }

  if (urlSections[0] === 'https:' && urlSections[1] === '') {

    if (urlSections[2] === 'media.giphy.com') {
      return urlSections[4].trim();
    }

    if (urlSections[2] === 'giphy.com' && urlSections[3] === 'gifs') {

      if (urlSections[5] === 'html5') {
        return urlSections[4].trim();
      }

      const sections = urlSections[4].split('-');
      
      if (sections.length > 0) {
        return sections[sections.length - 1].trim();
      }
    }
    
  }

  throw new Error(`Invalid Giphy URL: ${url}`);
}
